import { getPublic } from './api'

export const getBranding = async (domain: string) => {
    const url = domain // domain.includes('localhost') ? 'klanten.test2.tibimedia.nl' :
    return getPublic('/branding', {
        params: { domain: url }
    })
}
